import React, { useEffect } from 'react';
import { FieldValues, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup/dist/yup';

import { Input, SubmissionButtons } from '@components/common';

import { EValidationMode } from '@enums/validationMode';

import { schema } from './schema';

const nameField = 'name';

export type TOnSubmit = (values: FieldValues) => void;

interface IPresetCcFormParams {
	name?: string;
	onSubmit: TOnSubmit;
	onClose: () => void;
	setIsDirtyFormModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const PresetCcForm = ({
	name,
	onSubmit,
	onClose,
	setIsDirtyFormModal,
}: IPresetCcFormParams) => {
	const {
		formState: { errors, isDirty },
		handleSubmit,
		setValue,
		register,
	} = useForm<FieldValues>({
		mode: EValidationMode.all,
		resolver: yupResolver(schema),
		defaultValues: {
			[nameField]: name,
		},
	});

	useEffect(() => {
		if (!name) return;

		setValue(nameField, name);
	}, [name, setValue]);

	useEffect(() => setIsDirtyFormModal(isDirty), [isDirty, setIsDirtyFormModal]);

	return (
		<div>
			<Input
				errorMessage={errors?.name?.message}
				label='Preset Name'
				name={nameField}
				placeholder='Enter preset name'
				register={register}
				required
				setValue={setValue}
			/>
			<SubmissionButtons
				negativeHandler={onClose}
				positiveHandler={handleSubmit(onSubmit)}
				positiveLabel='Save'
			/>
		</div>
	);
};

export default PresetCcForm;
